// deals with info sharing encryption

const forge = require("node-forge");

module.exports = {
  
  
  encrypt: (data) => {
    // generates an aes128gcm compatible password
    // generate a random key and IV
    // Note: a key size of 16 bytes will use AES-128, 24 => AES-192, 32 => AES-256
    const key = {
      key: forge.random.getBytesSync(16),
      iv: forge.random.getBytesSync(12),
      verify: forge.random.getBytesSync(8), // read https://crypto.stackexchange.com/questions/42112/useful-additional-data-to-employ-in-gcm
    }
    
    let cipher = forge.cipher.createCipher('AES-GCM', key.key);
    cipher.start({
      iv: key.iv, // should be a 12-byte binary-encoded string or byte buffer
      additionalData: key.verify, // optional
      tagLength: 128 // optional, defaults to 128 bits
    });
    cipher.update( forge.util.createBuffer( JSON.stringify(data) ) );
    cipher.finish();
    let encrypted = cipher.output;
    let tag = cipher.mode.tag;
    
    let encryptedHex = encrypted.toHex();
    // console.log("encryptedHex:", encryptedHex);

    let tagHex = tag.toHex();
    // console.log("tagHex:", tagHex);
    
    // console.log("key1:", key);
 
    const out = JSON.stringify({
      data: encryptedHex,
      key: forge.util.bytesToHex(key.key),
      iv: forge.util.bytesToHex(key.iv),
      verify: forge.util.bytesToHex(key.verify),
      tag: tagHex,
    });
    
    return out;
    
  },
  
  
  // takes an object straight from the server:
  // {key: "", iv: "", verify: "", tag: "", data: ""}
  decrypt: (data) => {
    let tag = forge.util.hexToBytes(data.tag);
    let decipher = forge.cipher.createDecipher('AES-GCM', forge.util.hexToBytes(data.key) );
    decipher.start({
      iv: forge.util.hexToBytes(data.iv),
      additionalData: forge.util.hexToBytes(data.verify), // optional
      tagLength: 128, // optional, defaults to 128 bits
      tag: tag // authentication tag from encryption
    });
    
    // console.log("forge.util.hexToBytes(data.data):", forge.util.hexToBytes(data.data));
    decipher.update( forge.util.createBuffer( forge.util.hexToBytes( data.data ) ) );
    
    let pass = decipher.finish();
    // pass is false if there was a failure (eg: authentication tag didn't match)
    if (pass == true) {
      // outputs decrypted hex
      // console.log(decipher.output.toString());
      return decipher.output.toString();
    } else {
      throw "(ShareCrypto decryption) data not passed correctly";
    }
  },
  
}